import * as React from "react";
import {ISpecConfiguration} from "./SpecConfiguration";
import CardSelect, {ICardData} from "./CardSelect";

interface ISpecConfigurationBlockProps {
    baseSpec: ISpecConfiguration;
    visible: boolean;
    dataList: Array<any>;
    assignTo: string;
    onSelect: (selected: any) => void;
    createCardData: (item: any, specConfig: ISpecConfiguration) => ICardData;
    displayItems?: number;
    refreshTrigger: boolean;
    t: reactI18Next.TranslationFunction;
}

interface ISpecConfigurationBlockState {
    selectedIndex?: number;
    selectedItem?: any;
}

export default class SpecConfigurationBlock extends React.Component<ISpecConfigurationBlockProps, ISpecConfigurationBlockState> {
    state: ISpecConfigurationBlockState = {
        selectedIndex: undefined,
        selectedItem: undefined,
    };
    createCardData(item: any): ICardData {
        let param = Object.assign({}, this.props.baseSpec, {[this.props.assignTo]: item});
        return this.props.createCardData(item, param);
    }

    componentWillReceiveProps(nextProps: ISpecConfigurationBlockProps) {
        if (nextProps.refreshTrigger !== this.props.refreshTrigger) {
            let selItem = this.state.selectedIndex !== undefined ? nextProps.dataList[this.state.selectedIndex] : undefined;
            nextProps.onSelect(selItem);
        }
    }

    render() {
        let selItem = this.state.selectedIndex !== undefined ? this.props.dataList[this.state.selectedIndex] : undefined;
        if (this.state.selectedItem !== selItem) {
            this.setState({selectedItem: selItem});
            this.props.onSelect(selItem);
        }
        return (
            <div>
                {this.props.visible &&
                <span className="SpecConfigurationLine">
                    {this.props.children}
                    {this.props.dataList &&
                        <CardSelect
                            assignTo={this.props.assignTo}
                            displayItems={this.props.displayItems}
                            items={this.props.dataList}
                            selectedIndex={this.state.selectedIndex}
                            onIndexChange={(idx) => this.setState({selectedIndex: idx})}
                            mapToCard={(i: any) => this.createCardData(i)}
                            t={this.props.t}
                            
                        />
                    }
                </span>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/AdminView/SpecConfigTab/SpecConfigurationBlock.tsx